import React from 'react'
import GenericReport from '../GenericReport'

const TreatmentsByAdvisorPage: React.FC = () => {
  return <GenericReport reportId={1} />
}

export default TreatmentsByAdvisorPage
